import { createContext, useContext } from 'react';

// Utente autenticato ({ email, role }) fornito dal guard Auth
export const UserContext = createContext(null);

export const useCurrentUser = () => useContext(UserContext);

export const isSuperAdmin = (user) => Boolean(user && user.role === 'super-admin');
